import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { RoutingConfig } from '@app/routing/routing.config';
import { DevicesClass, DeviceTypes } from '@app/core/classes/component/devices.class';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'shared-main-menu',
  templateUrl: 'main-menu.component.html',
  styleUrls: [`./main-menu.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MainMenuComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;

  @Input() Device: DeviceTypes;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }
}
